// extracted by mini-css-extract-plugin
export default {"container":"DIDDescription_container__MKCdD","svgContainer":"DIDDescription_svgContainer__sKm5k"};